"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _vue = _interopRequireDefault(require("vue"));
var _Toast = _interopRequireDefault(require("./Toast"));
var _utils = require("../utils");
var defaultOptions = {
  iconName: '',
  type: 'text',
  mask: false,
  value: true,
  message: '',
  className: '',
  onClose: null,
  duration: 3000,
  forbidClick: false,
  loadingType: 'circular',
  getContainer: 'body',
  overlayStyle: null,
  iconSize: ''
};
var parseOptions = function parseOptions(message) {
  return (0, _utils.isObj)(message) ? message : {
    message: message
  };
};
var queue = [];
var multiple = false;
var currentOptions = Object.assign({}, defaultOptions);
function createInstance() {
  /* istanbul ignore if */
  if (_utils.isServer) {
    return {};
  }
  if (!queue.length || multiple || !(0, _utils.isInDocument)(queue[0].$el)) {
    var toast = new (_vue.default.extend(_Toast.default))({
      el: document.createElement('div')
    });
    queue.push(toast);
  }
  return queue[queue.length - 1];
}

// transform toast options to popup props
function transformer(options) {
  options.overlay = options.mask;
  return options;
}
function Toast(options) {
  if (options === void 0) {
    options = {};
  }
  var toast = createInstance();

  // should add z-index if previous toast has not disappeared
  if (toast.value) {
    toast.updateZIndex();
  }
  options = Object.assign({}, currentOptions, parseOptions(options), {
    clear: function clear() {
      toast.value = false;
      toast.resolve();
      if (options.onClose) {
        options.onClose();
      }
      if (multiple && !_utils.isServer) {
        clearTimeout(toast.timer);
        queue = queue.filter(function (item) {
          return item !== toast;
        });
        var parent = toast.$el.parentNode;
        if (parent) {
          parent.removeChild(toast.$el);
        }
        toast.$destroy();
      }
    }
  });
  Object.assign(toast, transformer(options));
  clearTimeout(toast.timer);
  if (options.duration > 0) {
    toast.timer = setTimeout(function () {
      toast.clear();
    }, options.duration);
  }
  var promise = new Promise(function (resolve, reject) {
    toast.resolve = resolve;
  });

  // 修复文档中的高级用法，在 Promise 化之后不生效的问题
  ['message', 'type'].forEach(function (key) {
    Object.defineProperty(promise, key, {
      set: function set(value) {
        toast[key] = value;
      }
    });
  });

  // 修复多实例模式下调用实例的 clear 方法失败的 bug
  promise.clear = toast.clear;
  return promise;
}
var createMethod = function createMethod(type) {
  return function (options) {
    return Toast(Object.assign({
      type: type
    }, parseOptions(options)));
  };
};
['loading', 'success', 'fail', 'network', 'warn'].forEach(function (method) {
  Toast[method] = createMethod(method);
});
Toast.clear = function (all) {
  if (queue.length) {
    if (all) {
      queue.forEach(function (toast) {
        toast.clear();
      });
      queue = [];
    } else if (!multiple) {
      queue[0].clear();
    } else {
      queue.shift().clear();
    }
  }
};
Toast.setDefaultOptions = function (options) {
  Object.assign(currentOptions, options);
};
Toast.resetDefaultOptions = function () {
  currentOptions = Object.assign({}, defaultOptions);
};
Toast.allowMultiple = function (value) {
  if (value === void 0) {
    value = true;
  }
  multiple = value;
};
Toast.install = function () {
  _vue.default.use(_Toast.default);
};
_vue.default.prototype.$toast = Toast;
var _default = Toast;
exports.default = _default;